import {
  IconBrandInstagram,
  IconCookie,
  IconDownload,
  IconMail,
} from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { ROUTE_ABOUT } from "../const/routes";
import Image from "./core/image/Image.tsx";
import { MODAL_INSTALL_NOTICE } from "./core/install/InstallNotice.tsx";
import { openModal } from "./core/PopUp.tsx";

const Footer = () => {
  const url = window.location.href;
  const openCookie = () => openModal("cookie-notice");
  const openInstall = () => openModal(MODAL_INSTALL_NOTICE);
  if (url.includes("inChat")) return null;
  return (
    <footer className="footer sm:footer-horizontal footer-center bg-base-300 text-base-content p-4 z-1">
      <aside>
        <button
          type="button"
          className="hover:link flex flex-col items-center justify-center"
          onClick={openCookie}
        >
          <h6 className="footer-title flex items-center justify-center gap-2">
            <IconCookie />
            Cookies?
          </h6>
        </button>
        <button
          type="button"
          className="hover:link flex flex-col items-center justify-center"
          onClick={openInstall}
        >
          <h6 className="footer-title flex items-center justify-center gap-2">
            <IconDownload />
            App installieren
          </h6>
        </button>
        <Link
          to={"https://www.instagram.com/surfanzeigen.de/"}
          className="hover:link flex flex-col items-center justify-center"
        >
          <h6 className="footer-title flex items-center justify-center gap-2">
            <IconBrandInstagram />
            Instagram
          </h6>
        </Link>

        <Link to={"mailto:kontakt@surfanzeigen.de"} className="hover:link ">
          <h6 className="footer-title flex items-center justify-center gap-2">
            <IconMail />
            Schick mir Feedback.
          </h6>
        </Link>
        <div className="flex justify-around">
          <Link
            className="btn btn-link text-base-content"
            to="https://www.linkedin.com/in/inga-petersen-544178346/"
          >
            <Image
              alt="Logo Surfanzeigen"
              src="/surfanzeigen-logo.svg"
              className="size-6 text-wrap"
            />
            Surfanzeigen-Logo von Inga Petersen
          </Link>
        </div>
        <div className="flex sm:flex-row flex-col justify-around">
          <Link
            className="btn btn-link text-base-content"
            to={`${ROUTE_ABOUT}#impressum`}
          >
            Impressum
          </Link>
          <Link
            className="btn btn-link text-base-content"
            to={`${ROUTE_ABOUT}#datenschutzerklaerung`}
          >
            Datenschutzerklärung
          </Link>
        </div>
      </aside>
    </footer>
  );
};

export default Footer;
